const signalR = require('@microsoft/signalr');

function getConnectionInfo(url, callback) {
    $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json",
        success: function (connectionInfo) {
            callback(connectionInfo);
        }
    });
}

window.InitPurchaseCallbackHandler = function (purchaseCallbackUrl, receiptUrl, errorUrl, cancelUrl) {
    getConnectionInfo(purchaseCallbackUrl, function (info) {
        const options = {
            accessTokenFactory: () => info.accessToken
        };

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(info.url, options)
            .configureLogging(signalR.LogLevel.Error)
            .build();

        connection.start().catch(console.error);

        connection.on('purchaseUpdated', (purchaseStatus) => {
            connection.stop().then(r => {
                switch (purchaseStatus) {
                    case PurchaseStatusEnum.PAID:
                        location.href = receiptUrl;
                        return;
                    case PurchaseStatusEnum.POSTPONED:
                        location.href = receiptUrl;
                        return;
                    //case PurchaseStatusEnum.CANCELLED:
                    //    errorUrl += "Payment_Cancelled";
                    //    location.href = cancelUrl;
                    //    return;
                    //case "error":
                    //    errorUrl += "Payment_Error";
                    //    location.href = errorUrl;
                    //    return;

                    case PurchaseStatusEnum.EXPIRED:
                        OpenExpiredModal();
                        return;
                    //default:
                    //    errorUrl += "Payment_Error";
                    //    location.href = errorUrl;
                    //    return;
                }
            });
        });
    });
}


const PurchaseStatusEnum = Object.freeze({
    DECLINED: "DECLINED",
    PENDING: "PENDING",
    PAID: "PAID",
    POSTPONED: "POSTPONED",
    REFUNDED: "REFUNDED",
    CANCELLED: "CANCELLED",
    EXPIRED: "EXPIRED"
});
